import * as React from 'react';
import { AppState } from '../../../Configs/Redux/AppState';
import { useSelector } from 'react-redux';
import { havePermissions } from './Permissions';

type AuthComponentProps = {
  children: JSX.Element;
  componentPermissions: Array<string>;
  hasAll?: boolean;
};

const AuthComponent: React.FunctionComponent<AuthComponentProps> = ({
  children,
  componentPermissions,
  hasAll = false,
}): JSX.Element | null => {
  const userPermissions: Array<string> = useSelector(
    (state: AppState) => state.App.user.roles
  );

  const isAuthenticated: boolean = havePermissions(
    componentPermissions,
    userPermissions,
    hasAll
  );

  return isAuthenticated ? children : null;
};

export default AuthComponent;
